"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ContactMethod_1 = require("../Model/ContactMethod");
const Collection_1 = require("../Model/Collection");
class ContactMethodRepository {
    /**
     * @inheritDoc
     */
    getAll() {
        return Promise.resolve(new Collection_1.default([
            new ContactMethod_1.default().setId('email'),
            new ContactMethod_1.default().setId('mobile'),
        ]));
    }
}
exports.default = ContactMethodRepository;
